module.exports = __webpack_public_path__ + "0c5e093c1d0d33c9758275922611141d.png";